import {formSelectedToggleColor, colorLight} from '@nib-components/theme';

export const SELECTED_STEP_COLOR = formSelectedToggleColor;
export const DEFAULT_STEP_COLOR = colorLight;
